import React, { createContext, useState, useMemo, useEffect, useContext } from "react"

import useDataApi from "../hooks/useDataApi"
import { fnGetBoard } from "../services/boards"
import AuthContext from "./Auth"
import { fnIsResponsible } from "../utils/permissions"
import PaineisContext from "./Paineis"
import { editModel } from "../services/boardsModel"

export const BoardContext = createContext(null)

export const BoardContextProvider = ({ children }) => {
  const [oBoardRes, fnGetBoardReq] = useDataApi(fnGetBoard)
  const [oCurrentBoard, fnSetOCurrentBoard] = useState(null)
  const [oUpdateBoardModelRes, fnUpdateBoardModelReq] = useDataApi(editModel)

  const { oUser } = useContext(AuthContext)
  const { oCurrentPanel } = useContext(PaineisContext)

  const nUserId = oUser?.data?.user_nid

  useEffect(() => {
    if (!oCurrentBoard) return

    const bIsResponsible =
      oCurrentPanel?.bIsResponsible ||
      fnIsResponsible(nUserId, oCurrentBoard?.responsibles)
    if (oCurrentBoard?.bIsResponsible === bIsResponsible) return
    fnSetOCurrentBoard({ ...oCurrentBoard, bIsResponsible })
  }, [oCurrentBoard])

  useEffect(() => {
    if(oUpdateBoardModelRes.loading) return
    if(oUpdateBoardModelRes?.data?.success){
      fnSetOCurrentBoard(prev => {
        return {...prev, board_model: oUpdateBoardModelRes?.data?.data}
      })
    }
  }, [oUpdateBoardModelRes])

  async function fnGetCurrentBoard(nPanelId, nBoardId) {
    if (!nPanelId || !nBoardId) return

    if (oCurrentBoard?.id === nBoardId || oBoardRes.loading) return

    const response = await fnGetBoardReq(nPanelId, nBoardId)
    fnSetOCurrentBoard(response?.data?.data?.[0])
  }

  async function fnRefreshCurrentBoard() {
    if (!oCurrentBoard) return
    const response = await fnGetBoardReq(oCurrentPanel?.id, oCurrentBoard?.id)
    fnSetOCurrentBoard(response?.data?.data?.[0])
  }
  async function fnUpdateBoardModel(id, aData){
    const result = await fnUpdateBoardModelReq(id, aData)
    
    return result
  }
  const value = useMemo(() => {
    return {
      oCurrentBoard,
      oBoardRes,
      fnSetOCurrentBoard,
      fnGetCurrentBoard,
      fnRefreshCurrentBoard,
      fnUpdateBoardModel,
      oUpdateBoardModelRes
    }
  }, [oCurrentBoard, oBoardRes, fnUpdateBoardModelReq, oUpdateBoardModelRes])

  return <BoardContext.Provider value={value}>{children}</BoardContext.Provider>
}

export default BoardContext
